import { all, call, put, take } from 'redux-saga/effects';

import { CREATE_CASE } from '../../account/type';
import {
  createCaseSuccessAction,
  createCaseErrorAction,
} from '../../account/action';
import { caseService } from 'services';

function* createCase() {
  while (1) {
    const action = yield take(CREATE_CASE);
    try {
      const { callback, patientId, token, data } = action.payload;

      const response = yield call(caseService.createCase, {
        patientId,
        token,
        data,
      });

      callback && callback(response);

      yield put(createCaseSuccessAction(response));
    } catch (error) {
      yield put(createCaseErrorAction(error));
    }
  }
}

export default function* rootSaga() {
  yield all([createCase()]);
}
